<section class="space-y-6">
  <div class="grid grid-cols-2 gap-4 lg:grid-cols-4">
    <div class="flex flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-800 dark:bg-slate-900">
      <span class="mb-1 text-xs font-black uppercase tracking-widest text-slate-400">{{ 'humanProfile.stats.totalRaces' | translate }}</span>
      <span class="text-3xl font-black text-slate-900 dark:text-slate-100">{{ totalRaces() }}</span>
    </div>
    <div class="flex flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-800 dark:bg-slate-900">
      <span class="mb-1 text-xs font-black uppercase tracking-widest text-slate-400">{{ 'humanProfile.stats.totalDistance' | translate }}</span>
      <span class="text-3xl font-black text-slate-900 dark:text-slate-100">{{ totalDistance() | distance }}<small class="ml-1 text-lg">km</small></span>
    </div>
    <div class="flex flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-800 dark:bg-slate-900">
      <span class="mb-1 text-xs font-black uppercase tracking-widest text-slate-400">{{ 'humanProfile.stats.avgSpeed' | translate }}</span>
      <span class="text-3xl font-black text-slate-900 dark:text-slate-100">{{ formatSpeed(averageSpeed()) }}<small class="ml-1 text-lg">km/h</small></span>
    </div>
    <div class="flex flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-800 dark:bg-slate-900">
      @if (points() !== null) {
        <span class="mb-1 text-xs font-black uppercase tracking-widest text-slate-400">{{ 'humanProfile.stats.points' | translate }}</span>
        <span class="text-3xl font-black text-slate-900 dark:text-slate-100">{{ points() }}</span>
      } @else if (showFavoriteDog()) {
        <span class="mb-1 text-xs font-black uppercase tracking-widest text-slate-400">{{ 'humanProfile.stats.favoriteDog' | translate }}</span>
        @if (favoriteDog(); as dog) {
          <a [routerLink]="['/dog-profile', dog.id]" class="link-accent max-w-full truncate text-lg font-black">{{ dog.name }}</a>
        } @else {
          <span class="text-3xl font-black text-slate-400">--</span>
        }
      } @else {
        <span class="mb-1 text-xs font-black uppercase tracking-widest text-slate-400">{{ 'humanProfile.stats.bestRank' | translate }}</span>
        <span class="text-3xl font-black text-slate-900 dark:text-slate-100">{{ bestRank() ? '#' + bestRank() : '--' }}</span>
      }
    </div>
  </div>

  <div class="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-800 dark:bg-slate-900 md:p-8">
    <div class="mb-6 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-lg font-black uppercase tracking-tight text-slate-900 dark:text-slate-100">{{ 'humanProfile.stats.byDiscipline' | translate }}</h3>
        <p class="mt-1 text-sm text-slate-500 dark:text-slate-400">{{ 'humanProfile.stats.byDisciplineDescription' | translate }}</p>
      </div>
      <span class="accent-soft flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border" aria-hidden="true"><svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg></span>
    </div>

    @if (disciplineStats().length > 0) {
      <div class="grid gap-3">
        <div class="hidden grid-cols-[minmax(10rem,1.4fr)_repeat(3,minmax(6rem,1fr))] gap-4 px-4 text-[10px] font-black uppercase tracking-widest text-slate-400 sm:grid">
          <span>{{ 'humanProfile.stats.discipline' | translate }}</span>
          <span class="text-right">{{ 'humanProfile.stats.racesByDiscipline' | translate }}</span>
          <span class="text-right">{{ 'humanProfile.stats.distanceByDiscipline' | translate }}</span>
          <span class="text-right">{{ 'humanProfile.stats.averageSpeedByDiscipline' | translate }}</span>
        </div>
        @for (item of disciplineStats(); track item.code) {
          <div class="grid gap-3 rounded-2xl bg-slate-50 p-4 dark:bg-slate-800/60 sm:grid-cols-[minmax(10rem,1.4fr)_repeat(3,minmax(6rem,1fr))] sm:items-center sm:gap-4">
            <div class="flex items-center gap-3">
              <span class="text-xl" aria-hidden="true">{{ item.icon }}</span>
              <span class="font-black text-slate-800 dark:text-slate-100">{{ item.labelKey | translate }}</span>
            </div>
            <div class="flex items-center justify-between gap-3 text-sm sm:block sm:text-right">
              <span class="text-xs font-black uppercase tracking-widest text-slate-400 sm:hidden">{{ 'humanProfile.stats.racesByDiscipline' | translate }}</span>
              <span class="font-black text-slate-700 dark:text-slate-200">{{ item.races }}</span>
            </div>
            <div class="flex items-center justify-between gap-3 text-sm sm:block sm:text-right">
              <span class="text-xs font-black uppercase tracking-widest text-slate-400 sm:hidden">{{ 'humanProfile.stats.distanceByDiscipline' | translate }}</span>
              <span class="font-black text-slate-700 dark:text-slate-200">{{ item.distance | distance }} km</span>
            </div>
            <div class="flex items-center justify-between gap-3 text-sm sm:block sm:text-right">
              <span class="text-xs font-black uppercase tracking-widest text-slate-400 sm:hidden">{{ 'humanProfile.stats.averageSpeedByDiscipline' | translate }}</span>
              <span class="font-black text-slate-700 dark:text-slate-200">{{ formatSpeed(item.averageSpeed) }} km/h</span>
            </div>
          </div>
        }
      </div>
    } @else {
      <p class="rounded-2xl bg-slate-50 p-5 text-sm font-bold text-slate-400 dark:bg-slate-800/60">{{ 'humanProfile.noResults' | translate }}</p>
    }
  </div>
</section>
